import { useHelper } from "@hooks/useHelper";
import { type ComponentProps } from "@ts/components";
import React, { useState, type FC } from "react";

export type QuestionsItemInputProps = ComponentProps & {
  userName: string;
  question: string;
  timeAgo: string;
  responses: {
    comments: string;
  }[];
  className?: string;
};

export type QuestionsItemOutputProps = Omit<
  QuestionsItemInputProps,
  "question"
> & {
  active: boolean;
  timeAgo: string;
  handleClick: () => void;
  questionTitle: string;
  response: string;
};

export const withQuestionsItem =
  (Component: FC<QuestionsItemOutputProps>) =>
  ({
    name = "QuestionsItem",
    className,
    timeAgo,
    question,
    responses,
    userName,
  }: QuestionsItemInputProps) => {
    const { unescape } = useHelper();
    const [active, setActive] = useState<boolean>(false);

    const questionTitle = unescape(question);
    const mappedResponses = responses?.map((response) => {
      const responseContent = unescape(response?.comments)?.replace(
        /(\r\n|\n|\r)/gm,
        "<br />",
      );

      return {
        ...response,
        comments: responseContent,
      };
    });

    const handleClick = () => {
      setActive((prev) => !prev);
    };

    Component.displayName = name;
    return (
      <Component
        active={active}
        timeAgo={timeAgo}
        userName={userName}
        responses={mappedResponses}
        className={className}
        handleClick={handleClick}
        questionTitle={questionTitle}
        response={responses?.[0]?.comments}
      />
    );
  };
